/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S1_P1Inputs */

const tr_kullanim_s1_p1 = /** @type {(inputs: Kullanim_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İşbu Kullanım Koşulları ("Sözleşme"), Emonse® E-Ticaret Limited Şirketi ("ShopPanel", "Şirket") ile ShopPanel™ platformunu kullanan gerçek veya tüzel kişi ("Kullanıcı") arasında geçerlidir. Platform'a erişim veya hesap oluşturma, bu Sözleşme'nin kabul edildiği anlamına gelir.`)
};

const en_kullanim_s1_p1 = /** @type {(inputs: Kullanim_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These Terms of Use ("Agreement") apply between Emonse® E-Ticaret Limited Şirketi ("ShopPanel", "Company") and the natural or legal person using the ShopPanel™ platform ("User"). Accessing the Platform or creating an account means that this Agreement is accepted.`)
};

const de_kullanim_s1_p1 = /** @type {(inputs: Kullanim_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Nutzungsbedingungen ("Vertrag") gelten zwischen der Emonse® E-Ticaret Limited Şirketi ("ShopPanel", "Unternehmen") und der natürlichen oder juristischen Person, die die Plattform ShopPanel™ nutzt ("Nutzer"). Der Zugriff auf die Plattform oder das Erstellen eines Kontos bedeutet, dass dieser Vertrag angenommen wird.`)
};

const ru_kullanim_s1_p1 = /** @type {(inputs: Kullanim_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настоящие Условия использования ("Договор") действуют между Emonse® E-Ticaret Limited Şirketi ("ShopPanel", "Компания") и физическим или юридическим лицом, использующим платформу ShopPanel™ ("Пользователь"). Доступ к Платформе или создание учётной записи означает принятие настоящего Договора.`)
};

/**
* | output |
* | --- |
* | "These Terms of Use (\"Agreement\") apply between Emonse® E-Ticaret Limited Şirketi (\"ShopPanel\", \"Company\") and the natural or legal person using the ShopPanel..." |
*
* @param {Kullanim_S1_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s1_p1 = /** @type {((inputs?: Kullanim_S1_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S1_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s1_p1(inputs)
	if (locale === "de") return de_kullanim_s1_p1(inputs)
	if (locale === "ru") return ru_kullanim_s1_p1(inputs)
	return tr_kullanim_s1_p1(inputs)
});